<template>
  <div class="w-full flex content-evenly gap-4 p-4
  bg-white sticky bottom-0 z-10">
    <p-button class="!w-1/2" outlined          
              :disabled="isLoading"
              @click="onCancel">
      <p-icon icon-name="close"
              color="blue" 
              class="mr-2"/>
      Annuleren
    </p-button>
    <p-button class="!w-1/2" :disabled="isSubmitDisabled"
              :loading="isLoading"
              @click="onSubmit">
      <p-icon icon-name="check"
              color="white"
              class="mr-2"/>
      Opslaan
    </p-button>            
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  isSubmitDisabled?: boolean
  isLoading?: boolean
  onSubmit?: () => void,
  onCancel?: () => void
}>();
</script>
